export default {
    typeProcessIndex: { method: 'get', url: 'signatures/type-processes' },
    typeProcessStore: { method: 'post', url: 'signatures/type-processes' },
    typeProcessUpdate: { method: 'put', url: 'signatures/type-processes/{id}' },
    typeProcessDestroy: { method: 'delete', url: 'signatures/type-processes/{id}' },
}